import { Component, OnInit } from '@angular/core';
import { UserSession } from '@mem-shared/user-session';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'mem-mapdnative-app-msg',
  templateUrl: './mapdnative-app-msg.component.html',
  styleUrls: ['./mapdnative-app-msg.component.scss']
})
export class MapdnativeAppMsgComponent implements OnInit {

  constructor(private router: Router,public userSession: UserSession) { }

  ngOnInit() {
  }

  goBack() {
    if (this.userSession.getSession('previousUrl') != '/multipleAccounts') {
      this.router.navigate(['/login']);
    }
    else {
      this.router.navigate(['/multipleAccounts']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/new-login-widget/mapdnative-app-msg/mapdnative-app-msg.component.ts